import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { userStartUpdate } from '../../../../actions/auth'
import { fetchConToken } from '../../../../helpers/fetch'

export const ModalUser = ({user, closeModal}) => {
  
    const dispatch = useDispatch()
    const initialState = {
        ...user  
    }
    const [formValues, setFormValues] = useState(initialState)  
    const {id,password,name,acces,email} = formValues

const [currentSelected, setCurrentSelected] = useState(user.acces)

const handleSelected = (select) => {
    setCurrentSelected(select)
    setFormValues({
        ...formValues,
        acces: select
    })
  }


    const handleInputChange = ({target}) => {

    setFormValues({
        ...formValues,
        
        [target.name]: target.value
    })
    }

    const handleSubmitForm = (e) =>{
        e.preventDefault()

        setFormValues({
            ...formValues
        })

        fetchConToken(`auth/users/${ id }`,formValues,'PUT');
       
        // window.location.reload(); 
        closeModal()
    }
    const handleDelete = () =>{
        console.log(user.id)
        Swal.fire({
            title: 'Quieres eliminar este usuario?',
            icon: 'warning',
            showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: 'Eliminar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                // dispatch(productStartDeleted(item))
                fetchConToken( `auth/users/${ user.id }`, {}, 'DELETE' );
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Usuario Eliminado',
                    showConfirmButton: false,
                    timer: 1500
                  })
              closeModal()
            } else if (result.isDenied) {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'El usuario NO ah sido eliminado',
                    showConfirmButton: false,
                    timer: 1000
                  })
            }
          })
    }

  return (
    <form    
        className="container _modal-form row"
        onSubmit={ handleSubmitForm }
    >
         <h5>Actualizar Usuario</h5>
            
            <input 
                className=' mt-2'
                type="text"           
                name="name"
                autoComplete="off"
                value={name}
                onChange={ handleInputChange }
                required
            />
            <input 
               className=' mt-2'
                type="email"                
                name="email"
                autoComplete="off"
                value={email}
                onChange={ handleInputChange }
                required
            />
            <input 
               className=' mt-2'
                type="password"                
                name="password"
                autoComplete="off"
                value={password}
                onChange={ handleInputChange }
                required
            />
            <select 
                    onChange={(event) => handleSelected(event.target.value)}
                    value={currentSelected}
                    className="select mt-2"
            >
                <option value="owner">Owner</option>
                <option value="admin">Admin</option>
                <option value="user">User</option>
                <option value="banned">Ban</option>
            </select>

            <div className='row mt-3'>

                                                    
                        <button
                            type="submit"
                            className="btn_blue col-6"
                        >

                            <span> Actualizar</span>
                        </button>

                        <div
                                className="btn_red col-6 "
                                onClick={handleDelete}
                        >

                            <span> Eliminar</span>
                        </div>
                                    

            </div>
   
        
    </form>
  )
}
